
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import Transcription from '@/store/modules/transcription';
import store from '@/store/store';
import {
  downloadDocx,
  downloadXML,
  downloadHTML,
  downloadText,
  downloadLaTeX,
} from '@/utils/download';

const trscModule = getModule(Transcription, store);

@Component
export default class TrscDownload extends Vue {
  get entry() {
    return trscModule.entry;
  }

  async downloadDocx() {
    return await downloadDocx(this.entry.id);
  }

  async downloadXML() {
    return await downloadXML(this.entry.id);
  }

  async downloadHTML() {
    return await downloadHTML(this.entry.id);
  }

  async downloadLaTeX() {
    return await downloadLaTeX(this.entry.id);
  }

  async downloadText() {
    return await downloadText(this.entry.id);
  }
}
